/**
 * CommunicationTemplate REST calls (legacy / admin tooling).
 * Kept separate from communications.js so campaign UI does not depend on email templates.
 */
import api, { API_BASE_URL } from './api';

function apiPath(suffix) {
  const p = suffix.startsWith('/') ? suffix : `/${suffix}`;
  const base = (API_BASE_URL || '').replace(/\/$/, '');
  if (base.endsWith('/api')) {
    return p;
  }
  return `/api${p}`;
}

function unwrapResults(res) {
  const d = res.data;
  if (d && Array.isArray(d.results)) {
    return {
      count: d.count ?? d.results.length,
      results: d.results,
      page: d.page ?? 1,
      page_size: d.page_size ?? d.results.length,
      total_pages: d.total_pages ?? 1,
      next: d.next,
      previous: d.previous,
    };
  }
  if (Array.isArray(d)) return { count: d.length, results: d, page: 1, page_size: d.length, total_pages: 1 };
  return { count: 0, results: [], page: 1, page_size: 0, total_pages: 0 };
}

/** GET /communications/templates/ — array or { results } */
export async function getTemplates() {
  const res = await api.get(apiPath('/communications/templates/'));
  const raw = res.data?.results ?? res.data ?? [];
  return Array.isArray(raw) ? raw : [];
}

export async function listTemplates() {
  const res = await api.get(apiPath('/communications/templates/'));
  return unwrapResults(res).results;
}

export async function createTemplate(payload) {
  const res = await api.post(apiPath('/communications/templates/'), payload);
  return res.data;
}

export async function updateTemplate(id, payload) {
  const res = await api.patch(apiPath(`/communications/templates/${id}/`), payload);
  return res.data;
}

export async function getTemplate(id) {
  const res = await api.get(apiPath(`/communications/templates/${id}/`));
  return res.data;
}
